import { nerdNetworkBaseQuery } from "@nerdjs/nerd-network";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseApi";

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery: (args, api) => baseQuery(args, api, { service: "account" }),
  endpoints: () => ({}),
  tagTypes: ["users", "verificationCodes", "organizations", "passkeys"],
});
